// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"94":"13bb4fd4a194005d","785":"a2c45740731f507d","811":"02412e5011b7c1a3"}[chunkId] + ".css";
};